export function parseCsv(data: string): any[] {
    const separator = detectSeparator(data);
    console.log("separator", separator);
    const flatData = Array.from(getCsvLines(data, separator));
    const firstRow = flatData.shift();
    if (!firstRow) return [];
    return flatData.map((row) => firstRow.reduce((obj: any, key, i) => ((obj[key] = row[i]) || 1) && obj, {}));
}

function* getCsvLines(source: string, separator: string) {
    let i = 0;
    let numberOfColumns = 0;
    for (const line of getLinesFromString(source)) {
        i++;
        if (line.trim() === "") continue;
        const values = Array.from(getCsvValueFromLine(line, separator)).map(x => decodeValue(x));
        if (numberOfColumns === 0) {
            numberOfColumns = values.length;
        } else if (values.length < numberOfColumns) {
            throw new Error(`CSV Parse: Invalid number of values (${values.length} / ${numberOfColumns}) on line ${i}`)
        }
        yield values;
    }
}

function* getLinesFromString(source: string) {
    let lines = String(source || "").matchAll(/^.+$/gm);
    for (const [line] of lines) yield line;
}

function* getCsvValueFromLine(source: string, separator: string) {
    const line = String(source || "");
    const sep = String(separator || ";");
    let inString = false;
    let start = 0;
    for (var i = 0; i < line.length; i++) {
        const char = line[i];
        if (i + 1 === line.length) {
            yield line.substring(start, i + 1); // or slice()
        } else if (!inString && char === sep) {
            yield line.substring(start, i); // or slice()
            start = i + 1;
        } else if (char === '"') {
            inString = !inString;
        }
    }
    if (line[line.length - 1] === sep) yield "";
}

const decodeValue = (val: string) => trimChars(val.trim(), "\"").replace(/""/gm, "\"");

function trimChars(s: string, c: string) {
    if (c === "]") c = "\\]";
    if (c === "^") c = "\\^";
    if (c === "\\") c = "\\\\";
    return s.replace(new RegExp("^[" + c + "]+|[" + c + "]+$", "g"), "");
}

function detectSeparator(data: string) {
    const indexOfComma = data.indexOf(',')
    const indexOfSemicolon = data.indexOf(';')
    if (indexOfComma > 0 && indexOfSemicolon > 0)
        return indexOfComma < indexOfSemicolon ? "," : ";";
    if (indexOfComma > 0) return ",";
    if (indexOfSemicolon > 0) return ";";
    return ",";
}
